import { MoreVert, SortDown } from 'iconoir-react'
import { useLottie } from "lottie-react"
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { lottieSupport, send } from '../../assets/index'
import { useSocket } from '../../redux_store/support/socket_hook'
import LoadingModal from '../templates/modals/LoadingModal'

const SupportPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedIssue, setSelectedIssue] = useState({});
  const [messages, setMessages] = useState([]);
  const [showDialog, setShowDialog] = useState({ sort: false, chatMoreOptions: false });
  const [typedMessage, setTypedMessage] = useState('');
  const [emptyMessage, setEmptyMessage] = useState('No Issue reported');
  const support = useSelector((state) => state.support);
  const socket = useSocket();

  const options = {
    animationData: lottieSupport,
    style: { height: 300, width: '100%' }
  };

  const { View } = useLottie(options);

  useEffect(() => {
    setIsLoading(false);
    if (selectedIssue._id) {
      const _selected = support.messages.filter((issue) => issue._id === selectedIssue._id)[0];
      if (_selected) {
        setSelectedIssue(_selected);
      }
    }
    setTypedMessage('');
    setMessages(support.messages);
    // eslint-disable-next-line
  }, [support]);

  function textAreaAdjust(e) {
    e.target.style.height = "0px";
    e.target.style.height = (0 + e.target.scrollHeight) + "px";
  }

  const handleMessageSend = () => {
    if (selectedIssue._id && typedMessage !== '') {
      setIsLoading(true);
      socket.replyIssueMessage(typedMessage, selectedIssue._id);
    }
  }

  const handleMessageTyped = (e) => {
    const { value } = e.target;
    setTypedMessage(value);
  }

  const handleChatOptionSelect = (e) => {
    const value = e.target.innerText;
    socket.updateIssueStatus(value, selectedIssue._id);
    setShowDialog({ ...showDialog, chatMoreOptions: false });
  }

  const handleIssueSorting = (e) => {
    const value = e.target.innerText;
    const filter = value === 'Issues Pending' ? 'Issue Pending' : value === 'Issues Resolved' ? 'Issue Resolved' : value;
    const _filtered = support.messages.filter((issue) => issue.status === filter);
    if (_filtered.length === 0)
      setEmptyMessage(`No issues ${filter.replace('-', ' ')}`);
    setMessages(_filtered);
    setShowDialog({ ...showDialog, sort: false });
  }

  return (
    <div className='bg-white shadow-md rounded-md m-10 grid grid-cols-3' style={{ height: '85%' }}>
      {isLoading && <LoadingModal message={'Sending...'} />}
      {showDialog.sort &&
        <div className='border text-sm rounded top-40 shadow-md shadow-gray-300 bg-white absolute'>
          <p className='px-3 pt-3 wayrideColor'>Sort chat by:</p>
          <ul onClick={handleIssueSorting} className='my-1'>
            <li className='cursor-pointer py-2 px-7 hover:bg-slate-100'>Issues Pending</li>
            <li className='cursor-pointer py-2 px-7 hover:bg-slate-100'>Issues Resolved</li>
            <li className='cursor-pointer py-2 px-7 hover:bg-slate-100'>Under Investigations</li>
          </ul>
        </div>
      }
      {showDialog.chatMoreOptions &&
        <div className='border text-sm rounded top-40 right-20 shadow-md shadow-gray-300 bg-white absolute'>
          <p className='px-3 pt-3 wayrideColor'>Mark As:</p>
          <ul onClick={handleChatOptionSelect} className='my-1'>
            <li className='cursor-pointer py-2 px-7 hover:bg-slate-100'>Issue Resolved</li>
            <li className='cursor-pointer py-2 px-7 hover:bg-slate-100'>Under Investigations</li>
          </ul>
        </div>
      }
      <div className=' my-2 overflow-hidden'>
        <div className='flex justify-between m-3'>
          <SortDown className='cursor-pointer' onClick={() => {
            setShowDialog({ ...showDialog, sort: true });
          }} />
          <p className='text-lg font-bold wayrideColor'>Issues Reported</p>
          <p></p>
        </div>
        <div className='h-full w-full overflow-y-auto'>
          {messages && messages.length > 0 ?
            messages.map((issue) =>
              <div
                onClick={() => setSelectedIssue(issue)}
                className={`h-16 ${issue._id === selectedIssue._id && 'bg-gray-300'} flex border-gray-300 cursor-pointer p-3 border-t hover:bg-gray-200`}>
                <img
                  className="object-cover w-10 h-full rounded-full"
                  src={issue.user && issue.user.profile_pic}
                  alt=""
                  loading="lazy"
                />
                <div className='ml-2 w-full'>
                  <div className='flex justify-between items-center'>
                    <p className='wayrideColor font-semibold text-slate-500'>
                      {issue.user ?
                        <>{issue.user && issue.user.surname} {issue.user && issue.user.other_names}</> : 'N/A'
                      }
                    </p>
                    <span className={`text-xs rounded-md px-1 ${issue.status === 'Issue Pending' ? 'text-yellow-600' :
                      issue.status === 'Under Investigations' ? 'wayrideColor' : 'text-green-600'}`
                    }>
                      {issue.status}
                    </span>
                  </div>
                  <div className='flex items-center justify-between'>
                    <p className='text-gray-600 text-xs'>{issue.category} issue</p>
                    {/* <small className='text-xs text-gray-100 rounded-full px-1 wayrideBgColor'>2</small> */}
                  </div>
                </div>
              </div>
            ) : <p className='text-sm mt-5 text-center italic text-gray-500'>{emptyMessage}</p>
          }
        </div>
      </div>
      {Object.keys(selectedIssue).length <= 0 ?
        <div className='border bg-white text-center flex items-center justify-center w-full shadow-md overflow-hidden rounded-md h-full col-span-2'>
          <section>
            {View}
            <br />
            <p className='text-slate-500 text-sm'>Provide support to issues raised by wayride users</p>
            <p className='text-slate-500 text-sm'>Issues can be marked as either <span className='wayrideColor font-bold'>resolved</span> or <span className='wayrideColor font-bold'>under investigation</span></p>
          </section>
        </div>
        :
        <div className='border shadow-md overflow-hidden rounded-md h-full col-span-2'>
          <div className="w-full h-full border flex flex-col">
            {/* <!-- Header --> */}
            <div className="py-2 border-b border-slate-300 px-3 bg-grey-lighter text-gray-600 flex flex-row justify-between items-center">
              <div className="flex items-center">
                <div>
                  <img
                    className="object-cover w-10 h-full rounded-full"
                    src={selectedIssue.user && selectedIssue.user.profile_pic}
                    alt=""
                    loading="lazy"
                  />
                </div>
                <div className="ml-4">
                  <p className="text-grey-darkest font-semibold text-gray-500">
                    {selectedIssue.user ?
                      <>{selectedIssue.user && selectedIssue.user.surname} {selectedIssue.user && selectedIssue.user.other_names}</> : 'N/A'
                    }
                  </p>
                  <p className="text-grey-darker text-xs mt-1">
                    <span className=''>Status:</span> {selectedIssue.status}
                  </p>
                </div>
              </div>
              <MoreVert onClick={() => {
                setShowDialog({ ...showDialog, chatMoreOptions: true })
              }} className="text-gray-800 cursor-pointer font-bold" />
            </div>

            {/* <!-- Messages --> */}
            <div className="overflow-auto bg-white h-full">
              <div className="py-2 px-6">
                {selectedIssue.messages && selectedIssue.messages.map((issue) => {
                  const thisMessageIndex = selectedIssue.messages.indexOf(issue);
                  const lastMessageIndex = thisMessageIndex - 1;
                  let thisMsgTimestamp = issue.timestamp, lastMsgTimestamp, showBanner, isSameDay;
                  if (lastMessageIndex >= 0) {
                    lastMsgTimestamp = selectedIssue.messages[lastMessageIndex].timestamp;
                    isSameDay = moment(thisMsgTimestamp).isSame(lastMsgTimestamp, 'day');
                    if (isSameDay) {
                      showBanner = false
                    } else {
                      showBanner = true;
                    }
                  } else {
                    showBanner = true;
                  }
                  return <>
                    {showBanner && <div className="flex justify-center mb-2">
                      <div className="rounded py-1 px-4" style={{ backgroundColor: '#DDECF2' }}>
                        <p className="text-xs uppercase">
                          {
                            moment(issue.timestamp).calendar(null, {
                              sameDay: '[Today]',
                              lastDay: '[Yesterday]',
                              lastWeek: '[Last] dddd',
                              sameElse: 'LL'
                            })
                          }
                        </p>
                      </div>
                    </div>}
                    <div className={`flex ${issue.from === 'support' && 'justify-end'} mb-2`}>
                      <div className="rounded py-2 px-3" style={{ backgroundColor: `${issue.from === 'user' ? '#F2F2F2' : '#E2F7CB'}` }}>
                        <p className="text-sm mt-1">
                          {issue.message}
                        </p>
                        <p className="text-right text-xs text-grey-dark mt-1">
                          {moment(issue.timestamp).format('h:mm a')}
                        </p>
                      </div>
                    </div>
                  </>
                })}
              </div>
            </div>

            {/* <!-- Input --> */}
            <div className=" mb-2 mx-3 border border-gray-300 rounded-md flex items-center">
              <div className="flex-1 space-x-2 flex ml-2">
                <textarea
                  onKeyUp={textAreaAdjust}
                  value={typedMessage}
                  rows={1}
                  placeholder="Enter message here..."
                  className="w-full pl-2 py-2 focus:outline-none placeholder:text-sm"
                  onChange={handleMessageTyped}
                />
                <button className=' px-2 wayrideBgColor rounded-md text-gray-100' onClick={handleMessageSend}><img src={send} alt="" width={25} /></button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default SupportPage